import { Suspense, lazy } from 'react';

import type { ChatMarkdownProps } from '@/components/ChatMarkdownContent';

// react-markdown and remark-gfm are ~50 kB gzipped and only ever needed once
// the chat sheet is open, so they get their own chunk rather than riding along
// in the initial bundle.
const importContent = () => import('@/components/ChatMarkdownContent');
const ChatMarkdownContent = lazy(importContent);

/**
 * Warm the chunk so a reply that starts streaming never has to fall back to
 * plain text. Called when the chat sheet opens: the download overlaps the time
 * the user spends typing, and repeat calls are free — the browser and bundler
 * both memoise the dynamic import.
 */
export function preloadChatMarkdown(): void {
  void importContent();
}

/**
 * Lazy boundary for the markdown renderer. The fallback is the plain-text
 * rendering these bubbles used before markdown existed, so a cold chunk
 * degrades to readable text rather than to an empty bubble.
 */
export function ChatMarkdown({ content, isDark, streaming = false }: ChatMarkdownProps) {
  return (
    <Suspense fallback={<div className="whitespace-pre-wrap">{content}</div>}>
      <ChatMarkdownContent content={content} isDark={isDark} streaming={streaming} />
    </Suspense>
  );
}
